<!-- Mobile-View Left Sidebar Navigation -->
<nav class="fw-SideNav" [ngClass]="{'opened': isOpen,'closed': !isOpen}" *ngIf="isMobileTheme || isTabletTheme">
	<ul class="fw-SideNav_FirstLevel margin-left-20">
		<nxi-icons [isPreLogin]="!isLoggedIn" (redirect)="toggle()"></nxi-icons>
		<ng-container *ngFor="let menu of menuItems">
			<li class="fw-SideNav_Link" [class.active]="menu.id === selectedPageId || menu.id === parentSelectedPageId" data-toggle="collapse" data-parent="#accordion" aria-expanded="false" aria-controls="item-0"
				id="nav-{{menu.id}}" *ngIf="menu.adaOnly !== true && !menu.hideFromNavigation">
				<!-- Naviagtion to handle teh pages that has only parent -->
				<!-- sample stephenresearch page -->
				<!-- <a class="nav-{{menu.id}}"  *ngIf="menu.id == 'overview'" href="javascript:void(0);" href="javascript:void(0);" (click)="handleNavigation(menu)">
					<span> <em class="fal fa-home"></em> </span>
					</a> -->
					<div class="fw-SideNav_Header" *ngIf="menu.id == 'overview' && !menu.isLink && menu.children.length === 0" >
						<a href="javascript:void(0);" class="fw-SideNav_Overview" (click)="handleNavigation(menu)">
							<div class="fw-SideNav_HomeIcon"></div>
							<span class="fw-SideNav_HeaderText">{{'HOME'| pershingTranslate}}</span>
						</a>
					</div>
				<div class="fw-SideNav_Header" *ngIf="menu.id != 'overview' && !menu.isLink && menu.children.length === 0" >
					<a href="javascript:void(0);" (click)="handleNavigation(menu)">{{menu.name| pershingTranslate}}</a>
				</div>
				<div class="fw-SideNav_Header" *ngIf="menu.id != 'overview' && menu.isLink && menu.children.length === 0" >
					<a href="javascript:void(0);" (click)="handleNavigationLink(menu)">{{menu.name| pershingTranslate}}</a>
				</div>
				<ng-container *ngIf="menu.id != 'overview' && menu.children.length > 0">
					<mat-accordion>
						<mat-nav-list>
							<mat-expansion-panel [expanded]="menu.id === menuId" (click)="expandMenuItem(menu.id)">
								<mat-expansion-panel-header>
									<div class="fw-SideNav_Header" id="nav-{{menu.id}}" *ngIf="menu.id != 'overview' && menu.children.length > 0">
										<span *ngIf="menu.id==='accounts'"></span>
										<span *ngIf="menu.id==='transact'"></span>
										<span *ngIf="menu.id==='wealthview'"></span>
										<span *ngIf="menu.id==='research'"></span>
										<span *ngIf="menu.id==='communications'"></span>
										<span class="fw-SideNav_HeaderText">{{menu.name| pershingTranslate}}</span>
									</div>
								</mat-expansion-panel-header>
								<ul class="fw-SideNav_SecondLevel padding-20">
									<ng-container *ngFor="let secondLevel of menu.children">
										<li *ngIf="!secondLevel.hideFromNavigation" [class.active]="selectedPageId == secondLevel.id">
											<a id="nav-{{secondLevel.id}}" href="javascript:void(0);" (click)="handleChildNavigation(menu,secondLevel)">
												<span class="fw-SideNav_Childmenu">
												{{ secondLevel.name | pershingTranslate}}
												</span>
											</a>
										</li>
									</ng-container>
								</ul>
							</mat-expansion-panel>
						</mat-nav-list>
					</mat-accordion>
				</ng-container>
			</li>
	    </ng-container>
		<div class="fw-SideNav_Footer">
			<div class="fw-Header_AccopenbtnDesktop small regular-weight margin-bottom-30 margin-right-10">
				<button *ngIf="isEntitledForAccountOpening && isNewAccOpenEnabled && !hideAcctOpening" (click)="openAnAccount()" mat-stroked-button
				 class="width-100 fw-Header_Icons no-border small regular-weight">{{ 'NXI_NAVIGATION.OPEN_ACCOUNT' | pershingTranslate}}
			  </button>
			  </div>
			<div *ngIf="isLoggedIn && isEdelEnabled && !isDisclosurePage" class="fw-SideNav_Link fw-SideNav_Border">
				<go-paperless></go-paperless>
			</div>
			<div tabindex="0" class="fw-SideNav_Header fw-SideNav_Link fw-SideNav_Border" *ngIf="entitledForContactUs && !isEquipt">
				<contact-us-adaptive></contact-us-adaptive>
			</div>
			<div class="fw-ProfileMenu_LastLogin" *ngIf="date && time && !hideLastLoginTime">
				<strong>{{'PROFILE_MENU.LAST_LOGIN' | translate}} </strong>
				<span class="fw-ProfileMenu_LoginDate"> {{ date }} <span class="separator">|</span> {{time}}
					{{'NXI_PORTAL_COMPONENTS.EASTERN_TIME' | translate}}</span>
			</div>
			<div tabindex="0" class="fw-SideNav_Header fw-ProfileMenu_Logout fw-SideNav_Border" (click)="logout()" *ngIf="isLoggedIn && !isSSOLogoutHide">
				<span class="fw-ProfileMenu_LogoutText"> {{ 'NXI_NAVIGATION.LOGOUT'  | translate}} </span>
				 <div class="fw-ProfileMenu_LogoutIcon"></div>
			</div>
		</div>
	</ul>
</nav>
